import React, { useState, useContext } from 'react'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Form, Button, Container } from 'react-bootstrap'

import config from '../config/config'
import NavigationBar from '../components/NavigationBar'
import AdminNavBar from '../components/Admin/AdminNavBar'
import Footer from '../components/Footer/Footer'
import { AuthContext } from '../contexts/AuthContext'
import { useAuth } from '../contexts/AuthContext'
import { MANAGE_EXTERNAL_LINKS_PATH, LOGIN_PATH } from '../config/routes'
import { useWebsite, setFlashMessage } from '../contexts/WebsiteContext'

const ManageExternalLink = () => {
  const { token } = useAuth()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { logout } = useContext(AuthContext)

  const [labelFr, setLabelFr] = useState('')
  const [labelEn, setLabelEn] = useState('')
  const [labelEs, setLabelEs] = useState('')
  const [urlFr, setUrlFr] = useState('')
  const [urlEn, setUrlEn] = useState('')
  const [urlEs, setUrlEs] = useState('')
  const [isAffiliateLink, setIsAffiliateLink] = useState(false)

  const handleSubmit = async (event) => {
    event.preventDefault()
    const data = {
      labelFr,
      labelEn,
      labelEs,
      urlFr,
      urlEn,
      urlEs,
      isAffiliateLink,
    }

    try {
      const response = await axios.post(`${config.apiUrl}external-link`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      })

      if (response.status === 201) {
        navigate(MANAGE_EXTERNAL_LINKS_PATH)
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        logout()
        navigate(LOGIN_PATH)
      } else if (error.response) {
        setFlashMessage(t('ERROR_MESSAGE'), 'error')
        console.log('Erreur lors du POST external-link')
      }
    }
  }

  return (
    <div>
      <NavigationBar />
      <AdminNavBar />
      <Container>
        <h2>{t('MANAGE_EXTERNAL_LINKS_NEW_TITLE')}</h2>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="labelFr">
            <Form.Label>{t('LABEL_FR')}</Form.Label>
            <Form.Control
              type="text"
              value={labelFr}
              onChange={(e) => setLabelFr(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group controlId="labelEn">
            <Form.Label>{t('LABEL_EN')}</Form.Label>
            <Form.Control
              type="text"
              value={labelEn}
              onChange={(e) => setLabelEn(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group controlId="labelEs">
            <Form.Label>{t('LABEL_ES')}</Form.Label>
            <Form.Control
              type="text"
              value={labelEs}
              onChange={(e) => setLabelEs(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group controlId="urlFr">
            <Form.Label>{t('URL_FR')}</Form.Label>
            <Form.Control
              type="text"
              value={urlFr}
              onChange={(e) => setUrlFr(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group controlId="urlEn">
            <Form.Label>{t('URL_EN')}</Form.Label>
            <Form.Control
              type="text"
              value={urlEn}
              onChange={(e) => setUrlEn(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group controlId="urlEs">
            <Form.Label>{t('URL_ES')}</Form.Label>
            <Form.Control
              type="text"
              value={urlEs}
              onChange={(e) => setUrlEs(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group controlId="isAffiliateLink">
            <Form.Check
              type="checkbox"
              label={t('IS_AFFILIATE_LINK')}
              checked={isAffiliateLink}
              onChange={(e) => setIsAffiliateLink(e.target.checked)}
            />
          </Form.Group>
          <Button variant="primary" type="submit">
            {t('SUBMIT')}
          </Button>
        </Form>
      </Container>
      <Footer />
    </div>
  )
}

export default ManageExternalLink
